import { timelineNodes } from '@/mocks/home';
import SectionHeading from './SectionHeading';

const toneMap = {
  primary: { dot: 'bg-primary-500', chip: 'bg-primary-100 text-primary-700' },
  accent: { dot: 'bg-accent-500', chip: 'bg-accent-100 text-accent-800' },
  secondary: { dot: 'bg-secondary-500', chip: 'bg-secondary-100 text-secondary-800' },
};

export default function TimelineSection() {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          id="timeline"
          tone="secondary"
          eyebrow="时间线"
          title="黑料爆料时间线 · 每个节点都有时间戳"
          desc="以小时为单位记录可核实的公开节点，标出哪些说法目前仍只有单方信源，方便自行判断。"
        />

        <div className="relative">
          <div className="absolute left-[15px] top-2 hidden h-[calc(100%-1rem)] w-px bg-background-300 md:left-1/2 md:block" />

          <ol className="space-y-4 md:space-y-0">
            {timelineNodes.map((node, index) => {
              const tone = toneMap[node.tone];
              const isRight = index % 2 === 1;
              return (
                <li key={node.title} className="relative md:grid md:grid-cols-2 md:gap-8">
                  <span
                    className={`absolute left-[15px] top-6 hidden h-3 w-3 -translate-x-1/2 rounded-full ring-4 ring-background-50 md:left-1/2 md:block ${tone.dot}`}
                  />
                  <div className={isRight ? 'md:col-start-2' : 'md:col-start-1 md:text-right'}>
                    <div
                      className={`rounded-lg border border-background-300 bg-background-100 p-4 transition-colors hover:border-primary-300 md:my-3 md:p-5`}
                    >
                      <div className={`flex items-center gap-2 ${isRight ? '' : 'md:justify-end'}`}>
                        <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-bold ${tone.chip}`}>{node.stage}</span>
                        <span className="font-mono text-xs text-foreground-500">{node.time}</span>
                      </div>
                      <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950">{node.title}</h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{node.desc}</p>
                    </div>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}